import {ChangePasswordType} from '../profile-type';

export const passwordChangeFieldsNames: Record<keyof ChangePasswordType, string> = {
    currentPassword: 'currentPassword',
    newPassword: 'newPassword',
    repeatNewPassword: 'repeatNewPassword',
};
